import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useParams, useNavigate, useLocation } from "react-router-dom";
import Swal from 'sweetalert2';
import SitagLogo from '../../../../styles/images/sitag-logo.png';
import { handleSetBackdropLoading } from '../../../../redux/actions/loaders';
import { BASE_SITE, TRANSFER_WALLET } from '../../../../apis'; 
import { handleSetOpenCustomSnackbar } from '../../../../redux/actions/snackbar';
import { handleChangeProfileData } from "../../../../redux/actions/pages/user/user";
import axios from "axios";
import * as qs from "querystring";

const PayResult = () => {

    const dispatch = useDispatch();

    const { token, profile } = useSelector(state => state.user);


    const {origin, status} = useParams();
    const navigate = useNavigate();

    const location = useLocation();
    const queryParams = new URLSearchParams(location.search);
    const transferAmount = queryParams.get("transferAmount");
    const transferBranch = queryParams.get("transferBranch");
    const transferService = queryParams.get("transferService");


    useEffect(() => {
        navigate('../');
        switch (origin) {
            case 'charge-wallet':
                if(transferAmount !== null && transferBranch !== null && transferService !== null) {
                    // navigate('../');
                    callApiTransfer(transferAmount, transferBranch, transferService);
                }
                else {
                    // navigate('../');
                    chargeWallet();
                }
                break;
            default:
                navigate('../');
        }

    });

    const btnOkSingle = Swal.mixin({
        customClass: {
            confirmButton: 'primary-border primary-txt-color font-weight-300 radius-12 w-100 py-2 px-5',
        },
        buttonsStyling: false
    });


    const chargeWallet = () => {
        if (status === 'ok') {
            btnOkSingle.fire({
                title: 'پرداخت موفق',
                text: 'شارژ کیف پول با موفقیت انجام شد.',
                imageUrl: SitagLogo,
                imageHeight: 80,
                imageAlt: 'سیتگ',
                confirmButtonText: "تایید",
            });
        } else {
            falsePayment();
        }
    };

    const falsePayment = () => {
        btnOkSingle.fire({
            title: 'پرداخت ناموفق',
            text: 'متاسفانه پرداخت شما موفقیت آمیز نبود.',
            imageUrl: SitagLogo,
            imageHeight: 80,
            imageAlt: 'سیتگ',
            confirmButtonText: "تایید",
        });
    };


    const callApiTransfer = (transferAmount, transferBranch, transferService) => {
        dispatch(handleSetBackdropLoading(true));

        axios({
            method: 'post',
            url: BASE_SITE + TRANSFER_WALLET,
            data: qs.stringify({
                amount: transferAmount,
                branch: (transferBranch / 341) - 227,
                service: (transferService / 142) - 312, 
            }),
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/x-www-form-urlencoded',
                'Authorization': token
            },
        }).then((response) => {
            switch (response.data.status) {
                case 'error':
                    dispatch(handleSetOpenCustomSnackbar(true, {message: response.data.message, severity: 'error', vertical: 'bottom', horizontal: 'center'}));  
                    break;
                case 'ok':
                    let newProfile = {...profile, 
                        user_credit: response.data.user_credit, 
                        user_org_credit: response.data.user_org_credit, 
                    };
                    dispatch(handleChangeProfileData(newProfile));

                    btnOkSingle.fire({
                        title: "تایید",
                        text: `مبلغ ${parseInt(transferAmount).toLocaleString()} ریال با موفقیت به حساب ${response.data.shop_title} ${response.data.branch_title} منتقل شد`,
                        imageUrl: SitagLogo,
                        imageHeight: 80,
                        imageAlt: 'سیتگ',
                        confirmButtonText: "باشه",
                    });
                    break;
                default:
                    dispatch(handleSetOpenCustomSnackbar(true, {message: 'خطا در اتصال به سرور! لطفا مجددا تلاش کنید.', severity: 'error', vertical: 'top', horizontal: 'right'}));  
            }
            dispatch(handleSetBackdropLoading(false));
        }, () => {
            dispatch(handleSetBackdropLoading(false));
            dispatch(handleSetOpenCustomSnackbar(true, {message: 'خطا در اتصال به سرور! لطفا مجددا تلاش کنید.', severity: 'error', vertical: 'top', horizontal: 'right'}));  
        });
    };


    return null;
};

export default PayResult;
